/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfAccountingV1ConfigState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_ACCOUNTING_V1_CONFIG_STATE_ENTITY_NAME = 'ixf.accounting.v1.Config';
export const ixfAccountingV1ConfigStateEntity = new schema.Entity<IxfAccountingV1ConfigState>(IXF_ACCOUNTING_V1_CONFIG_STATE_ENTITY_NAME, {}, { idAttribute: 'global' });

